import { limitFill } from '@cloudinary/url-gen/actions/resize';

import { env } from '../../env';
import { cloudinary } from '../../services/cloudinary';
import { CloudinaryAsset } from '../../types/schemas/objects/CloudinaryAsset';
import { cloudinaryCloudRegExp, cloudinaryProxyRegExp } from './constants';
import { getCloudinaryAssetProxyUrl } from './getCloudinaryAssetProxyUrl';
import { getImageTransformations } from './getImageTransformations';

export const cloudinaryImageOptimizerLoader =
	(data: CloudinaryAsset) =>
	({ src, width }: { src: string; width: number }) => {
		// Storybook and some local environments may miss cloudName; use the original asset URL then.
		if (!env.cloudinary.cloudName) {
			return data.secure_url || data.url || src;
		}

		const image = cloudinary
			.image(src)
			.setURLConfig({
				analytics: false,
			})
			.resize(limitFill().width(width));

		if (cloudinaryProxyRegExp.test(src) || cloudinaryCloudRegExp.test(src)) {
			image.setDeliveryType('fetch');
		}

		if (data.format === 'svg') {
			return getCloudinaryAssetProxyUrl(image.toURL());
		}

		const transformation = getImageTransformations(data);
		image.addTransformation(transformation).quality('auto:eco').format('auto');

		return getCloudinaryAssetProxyUrl(image.toURL());
	};
